export const isIndiaRegion = (qbRegion?: string | null): boolean =>
  (qbRegion || '').trim().toLowerCase() === 'india';
